module.exports = __webpack_public_path__ + "static/img/444_03.bf27c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/444_03.png
// module id = Uoi3
// module chunks = 0